import {
  Grid,
  IconButton,
  Typography,
  Paper,
  CardContent,
} from "@mui/material";
import { useSnack } from "../../redux/snack/snackHooks";
import { useState, useCallback, useEffect } from "react";
import { Card, makeStyles } from "@material-ui/core";
import {
  DadosAnexosEmissaoCTe,
  DadosSolicitacaoEmissao,
} from "../../model/entities/SolicitacaoEmissaoCTe";
import dayjs from "dayjs";
import { Close, AttachFile, CloudUpload } from "@mui/icons-material";
import { useDropzone } from "react-dropzone";
import solicitacaoEmissaoCTeApi from "../../api/solicitacaoEmissaoCTeApi";
import TextFieldGeneric from "../../components/Generics/TextFieldGeneric";
import ButtonGeneric from "../../components/Generics/ButtonGeneric";
import DateTimePickerExample from "../../components/Generics/DateTimePicker";
import LoadingBackdrop from "../../components/Generics/LoadingBackdrop";

type Props = {
  solicitacao: DadosSolicitacaoEmissao;
};

const InformacoesDescarregamento: React.FC<Props> = (props) => {
  const { solicitacao } = props;
  const mostrarSnack = useSnack();
  const classes = useStyles();
  const [carregandoAnexos, setCarregandoAnexos] = useState(false);
  const [anexosInfoDescarga, setAnexosInfoDescarga] = useState<File[]>([]);
  const [destinoCarga, setDestinoCarga] = useState(solicitacao.destinoCarga);
  const [observacoes, setObservacoes] = useState(solicitacao.observacoes);
  const [dataAgendamento, setDataAgendamento] = useState(
    solicitacao.dataHoraAgendamento
      ? solicitacao.dataHoraAgendamento
      : dayjs().toDate()
  );

  const onDropInfoDescarga = useCallback(
    (acceptedFiles: File[]) => {
      setAnexosInfoDescarga([...anexosInfoDescarga, ...acceptedFiles]);
      mostrarSnack("Arquivos adicionados com sucesso!", "success");
    },
    [anexosInfoDescarga, mostrarSnack]
  );

  useEffect(() => {
    getAnexos();
  }, []);

  const getAnexos = async () => {
    try {
      setCarregandoAnexos(true);
      const res: DadosAnexosEmissaoCTe[] =
        await solicitacaoEmissaoCTeApi.getAnexosSolicitacao(solicitacao.id);

      const arquivosInfoDescarga: File[] = res
        .filter((item) => item.tipoAnexo === "INFO_DESCARGA")
        .map((item) => {
          const byteString = atob(item.arquivo); // decodifica base64
          const arrayBuffer = new ArrayBuffer(byteString.length);
          const uint8Array = new Uint8Array(arrayBuffer);

          for (let i = 0; i < byteString.length; i++) {
            uint8Array[i] = byteString.charCodeAt(i);
          }

          const blob = new Blob([uint8Array], { type: item.tipoConteudo });
          return new File([blob], item.nomeArquivo, {
            type: item.tipoConteudo,
          });
        });

      setAnexosInfoDescarga(arquivosInfoDescarga);
      setCarregandoAnexos(false);
    } catch (erro: any) {
      mostrarSnack("Erro ao buscar anexos", "error");
      console.log("Erro ao buscar anexos", erro);
      setCarregandoAnexos(false);
    }
  };

  const salvar = async () => {
    try {
      setCarregandoAnexos(true);
      const dados: DadosSolicitacaoEmissao = {
        ...solicitacao,
        destinoCarga: destinoCarga,
        observacoes: observacoes,
        dataHoraAgendamento: dataAgendamento,
      };

      await solicitacaoEmissaoCTeApi.uploadAnexosDescarregamento(
        solicitacao.id,
        anexosInfoDescarga,
        dados
      );
      mostrarSnack("Anexos enviados para o motorista", "success");
      setCarregandoAnexos(false);
    } catch (erro: any) {
      setCarregandoAnexos(false);
      mostrarSnack("Erro ao enviar anexo ao motorista", "error");
      console.log("Erro ao enviar anexo ao motorista", erro);
    }
  };

  const {
    getRootProps: getRootPropsInfoDescarga,
    getInputProps,
    isDragActive,
  } = useDropzone({
    onDrop: onDropInfoDescarga,
    accept: {
      "image/*": [".jpeg", ".jpg", ".png"],
      "application/pdf": [".pdf"],
    },
  });

  const handleRemoveFileInfoDescarga = (index: number) => {
    const newAnexos = [...anexosInfoDescarga];
    newAnexos.splice(index, 1);
    setAnexosInfoDescarga(newAnexos);
    mostrarSnack("Arquivo removido", "info");
  };

  // const naoPodeMaisEnviar =
  //   passouDe24Horas(solicitacao.dataHoraSolicitacao) ||
  //   solicitacao.status === "EMITIDO";

  if (carregandoAnexos) {
    return <LoadingBackdrop open={carregandoAnexos} />;
  }

  const naoPodeMaisEnviar = false;
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Card
          style={{
            boxShadow: "0 2px 10px rgba(0, 0, 0, 0.15)",
          }}
        >
          <CardContent>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <DateTimePickerExample
                  value={dataAgendamento}
                  label="Data e hora do agendamento"
                  disabled={naoPodeMaisEnviar}
                  setValue={(value) => {
                    setDataAgendamento(value);
                  }}
                />
              </Grid>

              <Grid item xs={12}>
                <TextFieldGeneric
                  label={"Destino carga"}
                  value={destinoCarga}
                  onChange={(value) => setDestinoCarga(value)}
                />
              </Grid>

              <Grid item xs={12}>
                <TextFieldGeneric
                  label={"Observações"}
                  maxLength={1000}
                  exibirMaxLength
                  value={observacoes}
                  onChange={(value) => setObservacoes(value)}
                />
              </Grid>

              {/* Anexos info descarga */}
              <Grid item md={12}>
                {!naoPodeMaisEnviar && (
                  <>
                    <Typography
                      variant="subtitle1"
                      className={classes.sectionTitle}
                    >
                      <AttachFile
                        fontSize="small"
                        className={classes.titleIcon}
                      />
                      Anexe aqui, arquivos com informações para o agendamento de
                      descarga
                    </Typography>

                    <Paper
                      {...getRootPropsInfoDescarga()}
                      className={classes.dropzone}
                      elevation={0}
                    >
                      <input {...getInputProps()} />
                      <CloudUpload className={classes.uploadIcon} />
                      {isDragActive ? (
                        <Typography>Solte os arquivos aqui...</Typography>
                      ) : (
                        <div className={classes.dropzoneText}>
                          <Typography>
                            Arraste e solte arquivos aqui ou clique para
                            selecionar
                          </Typography>
                          <Typography variant="caption">
                            Suporta arquivos nos formatos JPG, PNG e PDF.
                          </Typography>
                        </div>
                      )}
                    </Paper>
                  </>
                )}

                <Grid container spacing={1} className={classes.anexosContainer}>
                  {anexosInfoDescarga.map((anexo, index) => {
                    const fileUrl = URL.createObjectURL(anexo);

                    return (
                      <Grid item md={12} xs={12}>
                        <a
                          href={fileUrl} // URL temporária para o arquivo
                          target="_blank"
                          rel="noopener noreferrer" // Boa prática para segurança
                          style={{ textDecoration: "none", color: "inherit" }}
                        >
                          <Paper
                            elevation={1}
                            className={classes.imageContainer}
                          >
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                              }}
                            >
                              {/* Tornando o nome do arquivo clicável */}
                              <Typography variant="body2">
                                {anexo.name}
                              </Typography>

                              {!naoPodeMaisEnviar && (
                                <IconButton
                                  size="small"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleRemoveFileInfoDescarga(index);
                                  }}
                                >
                                  <Close fontSize="small" />
                                </IconButton>
                              )}
                            </div>
                          </Paper>
                        </a>
                      </Grid>
                    );
                  })}
                </Grid>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>

      {!naoPodeMaisEnviar && anexosInfoDescarga.length > 0 && (
        <Grid item xs={12} style={{ textAlign: "center", marginTop: "15px" }}>
          <ButtonGeneric label={"Enviar ao motorista"} onClick={salvar} />
        </Grid>
      )}
    </Grid>
  );
};

const useStyles = makeStyles((theme) => ({
  input: {
    width: "100%",
    minWidth: "350px",
    marginBottom: "35px",
    "@media (max-width: 768px)": {
      minWidth: "400px",
      marginBottom: "20px",
    },
  },
  button: {
    backgroundColor: "#3a7bd5 !important",
    color: "#fff !important",
    "&:hover": {
      backgroundColor: "#306bb5 !important",
    },
  },
  footer: {
    display: "flex",
    flexDirection: "column",
    marginTop: "auto",
    width: "100%",
    justifyContent: "center",
    alignItems: "center",
  },
  sectionTitle: {
    fontWeight: 600,
    marginBottom: 10,
    display: "flex",
    alignItems: "center",
  },
  titleIcon: {
    marginRight: 8,
    color: "#666",
  },

  imageContainer: {
    textAlign: "center",
    padding: 10,
    cursor: "pointer",
    transition: "all 0.2s",
    "&:hover": {
      backgroundColor: "rgba(0,0,0,0.05)",
    },
  },

  imageCaption: {
    color: "#3a7bd5",
    display: "block",
    marginTop: 8,
  },
  dropzone: {
    border: "2px dashed #ccc",
    borderRadius: 4,
    padding: 20,
    textAlign: "center",
    cursor: "pointer",
    backgroundColor: "rgba(0,0,0,0.02)",
    transition: "border 0.2s",
    "&:hover": {
      borderColor: "#3a7bd5",
    },
  },
  uploadIcon: {
    fontSize: 40,
    color: "#3a7bd5",
    marginBottom: 10,
  },
  dropzoneText: {
    marginTop: 8,
  },
  anexosContainer: {
    marginTop: "25px",
  },
  anexoItem: {
    position: "relative",
    height: 120,
    overflow: "hidden",
    margin: 0,
  },
  anexoItemPrincipal: {
    position: "relative",
    height: 120,
    overflow: "hidden",
    margin: 0,
    textDecoration: "none",
    color: "inherit",
  },
  anexoContent: {
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
  },
  anexoImage: {
    maxWidth: "100%",
    maxHeight: "100%",
    objectFit: "contain",
  },
  pdfPreview: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    color: "#e53935",
    height: "100%",
  },
  removeButton: {
    position: "absolute",
    top: 0,
    right: 0,
    backgroundColor: "rgba(255,255,255,0.7)",
    padding: 2,
    "&:hover": {
      backgroundColor: "rgba(255,255,255,0.9)",
    },
  },
  dialogContent: {
    position: "relative",
    padding: 8,
  },
  dialogImage: {
    maxWidth: "100%",
    maxHeight: "80vh",
    display: "block",
    margin: "0 auto",
  },
  closeButton: {
    position: "absolute",
    top: 8,
    right: 8,
    backgroundColor: "rgba(0,0,0,0.5) !important",
    color: "#fff !important",
    zIndex: 1,
    "&:hover": {
      backgroundColor: "rgba(0,0,0,0.7) !important",
    },
  },
}));

export default InformacoesDescarregamento;
